export enum EvaluationPermissions {
  Read = 'EVALUATIONS:EVALUATION:READ',
  Update = 'EVALUATIONS:EVALUATION:UPDATE',
}
